import { createContext, useContext } from 'react';
import type { ParticleLayerHandle } from '../components/ParticleLayer';

// Re-export the handle type for convenience
export type ParticleContextType = ParticleLayerHandle | null;

export const ParticleContext = createContext<ParticleContextType>(null);

/**
 * Hook to access the global particle system.
 * Use this in any component to trigger effects like: spawnSprite, spawnHit, etc.
 * 
 * @example
 * const particles = useParticles();
 * particles?.spawnSprite(x, y, config);
 */
export function useParticles(): ParticleContextType {
    return useContext(ParticleContext);
}
